function queryParams(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(url);
  return results == null ? null : results[1];
}

export { queryParams as qp };
export default queryParams;
